module.exports = __webpack_public_path__ + "img/second-day-4.ed450598.webp";